"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DataGridContextProvider: function() {
        return DataGridContextProvider;
    },
    dataGridContextDefaultValue: function() {
        return dataGridContextDefaultValue;
    },
    useDataGridContext_unstable: function() {
        return useDataGridContext_unstable;
    }
});
const _reactcontextselector = require("@fluentui/react-context-selector");
const _hooks = require("../hooks");
const dataGridContext = (0, _reactcontextselector.createContext)(undefined);
const dataGridContextDefaultValue = {
    ..._hooks.defaultTableState,
    subtleSelection: false,
    selectableRows: false,
    selectionAppearance: 'brand',
    focusMode: 'none',
    compositeRowTabsterAttribute: {}
};
const DataGridContextProvider = dataGridContext.Provider;
const useDataGridContext_unstable = (selector)=>(0, _reactcontextselector.useContextSelector)(dataGridContext, (ctx = dataGridContextDefaultValue)=>selector(ctx));
